import {User} from "../interfaces/User";
import {isStringNotEmptyOrNull} from "../utils";

export function isThirdPartyUser(user:User | null) {
    return isStringNotEmptyOrNull(user?.third_party_id ?? "");
}